"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBtn = exports.ThumbnailContainer = exports.Thumbnail = exports.RightBottomTool = exports.StyledLabel = exports.Container = exports.StyledInput = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const theme_1 = require("../../theme/theme");

exports.StyledInput = styled_components_1.default.input.attrs({
  type: 'file'
})`
  display: none;
`;
exports.Container = styled_components_1.default.div`
  width: 100%;
  min-width: 80px;
  aspect-ratio: 1 / 1;
`;
exports.StyledLabel = styled_components_1.default.label`
  border: 1px dashed ${theme_1.mainTheme.colors.primary_400};
  width: 100%;
  height: 100%;
  border-radius: 3px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
exports.RightBottomTool = styled_components_1.default.div`
  position: absolute;
  right: 0px;
  bottom: 0px;
  margin: 10px;
  background: white;
  border-radius: 3px;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 3px;
`;
exports.Thumbnail = styled_components_1.default.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
`;
exports.ThumbnailContainer = styled_components_1.default.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 3px;
  overflow: hidden;
  ${props => props.loading && (0, styled_components_1.css)`
      filter: blur(3px);
    `}
`;
exports.IconBtn = styled_components_1.default.button`
  width: 20%;
  height: 20%;
  min-height: 20px;
  min-width: 20px;
  max-width: 40px;
  max-height: 40px;
  box-shadow: 2px black;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0;
  cursor: pointer;
  background-color: inherit;
`;